import styled, { css } from 'styled-components';
import { styled as materialStyles } from '@material-ui/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
// import { lighten } from 'polished';
import Chip from '@material-ui/core/Chip';
import { grey, purple, red } from '@material-ui/core/colors';

export const FieldWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: ${(props) => (props.flexGrow ? 1 : 0)};
  justify-content: center;

  background-color: inherit;
  border: 1px solid ${grey[200]};
  border-color: var(--border-color);
  border-radius: 6px;

  margin: 0;
  min-width: 70px;
  padding: 0.5em 1em;
  position: relative;

  label {
    color: var(--text-color);
    font-size: 0.7em;
    margin-bottom: 0.5rem;
  }

  input {
    color: var(--text-color);
    font-size: 0.9em;
    padding: 0;
  }

  textarea {
    background-color: inherit;
    color: var(--text-color);
    min-height: 150px;
  }

  ${(props) => props.small
    && css`
      margin: 0.25em;

      input {
        font-size: 0.9em;
      }
    `}

  ${(props) => props.noWrapper
    && css`
      background-color: transparent;
      border: none;
      padding: 0;
    `}

  ${(props) => props.noMargin
    && css`
      margin: 0;
    `}
`;

export const PhoneInputWrapper = styled(FieldWrapper)`
  margin-top: 8px;
  margin-bottom: 4px;
  padding: 0 1em;
  width: 100%;
  box-sizing: border-box;

  ${(props) => props.light
    && css`
      border-color: ${grey[200]};
    `}

  &:focus {
    border-color: ${purple[200]};
  }

  .PhoneInputInput {
    padding: 0.5rem 0;
    border-color: transparent !important;
    background-color: transparent !important;

    &:focus {
      border-color: transparent !important;
      outline: none;
    }
  }
`;

export const AutoCompleteContainer = styled.div`
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 6px;

  position: absolute;
  left: 0;
  top: 100%;
  z-index: 999;
`;

export const AutoCompleteItem = styled.div`
  background-color: white;
  cursor: pointer;

  padding: 0.5em 1em;
  transition: background-color 0.3s ease;

  &.active {
    background-color: ${grey[50]};
  }
`;

export const DateFieldInput = styled.div`
  .DateInput_fang {
    top: 22px !important;
    z-index: 999 !important;
  }

  .SingleDatePicker_picker {
    top: 33px !important;
    z-index: 998 !important;
  }

  .DateInput_input {
    box-sizing: border-box;
    padding: 0;

    color: ${grey[600]};
    font-size: 0.9em;
    line-height: 1;
    border-bottom: none;
  }
`;

export const StyledLabel = materialStyles(InputLabel)({
  marginBottom: '0.5em',
});

export const StyledSelect = withStyles((theme) => ({
  root: {
    backgroundColor: 'inherit',
    color: 'var(--text-color)',
  },
  select: {
    backgroundColor: 'inherit',
    color: 'var(--text-color)',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
    '&:focus': {
      backgroundColor: 'inherit',
    },
  },
}))(Select);

export const StyledInput = withStyles({
  root: {
    backgroundColor: 'inherit',
    color: 'var(--text-color)',
    fontSize: '0.9em',
    position: 'relative',
    zIndex: '1',
  },
  focused: {
    backgroundColor: 'inherit',
    color: grey[600],
  },
})(InputBase);

export const StyledButton = materialStyles(Button)((props) => ({
  backgroundColor: props.bgcolor || 'var(--background-color)',
  borderColor: props.bgcolor || 'var(--border-color)',
  color: props.textcolor || 'var(--text-color)',

  padding: '1em',
  width: props.fullWidth ? '100%' : 'auto',

  '&:hover': {
    backgroundColor: props.bgcolor || 'var(--background-color)',
    borderColor: props.bgcolor || 'var(--border-color)',
  },
}));

export const StyledIconButton = materialStyles(IconButton)((props) => ({
  color: props.textcolor || 'var(--text-color)',
  flexGrow: props.grow ? 1 : 0,
}));

export const ColorButton = materialStyles(Button)((props) => ({
  backgroundColor: props.bgcolor || 'var(--background-color)',
  borderColor: props.bgcolor || 'var(--border-color)',
  color: props.textcolor || 'var(--text-light-color)',
  flexGrow: props.grow ? 1 : 0,

  '&:hover': {
    backgroundColor: props.bgcolor || 'var(--background-color)',
    borderColor: props.bgcolor || 'var(--border-color)',
  },

  outlined: {
    backgroundColor: 'transparent',
    color: props.textcolor || props.bgcolor || 'var(--background-color)',
  },
}));

export const CssFormControl = withStyles({
  root: {
    margin: '1em 0 0.5em !important',
    '& p.error': {
      color: red[600],
    },
    '& .react-phone-number-input': {
      border: '1px solid',
      borderColor: 'var(--border-color)',
      borderRadius: '0.25rem',
      padding: '1em',

      '&--focus': {
        borderColor: purple[400],
      },

      '&.error': {
        borderColor: red[600],
      },
    },
    '& input[type="tel"]': {
      border: 'none',
      background: 'transparent',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'var(--border-color)',
      },
      '&:hover fieldset': {
        borderColor: 'var(--border-color)',
      },
      '&.Mui-focused fieldset': {
        borderColor: purple[400],
      },
    },
  },
})(FormControl);

export const ChipCSS = withStyles({
  root: {
    height: 'auto',
    marginRight: '0.5em',
  },
  label: {
    padding: '0 0.5rem',
    fontSize: '0.7rem',
  },
})(Chip);

export const StyledSVG = styled.svg`
  margin-right: 1em;
`;

export const StyledIcon = styled.div`
  color: var(--text-color);
  margin-right: 1em;
`;

export const CssTextField = withStyles({
  root: {
    '& fieldset': {
      border: '1px solid !important',
      borderColor: 'var(--border-color) !important',
      color: 'var(--text-color)',
    },
    '& label.Mui-focused': {
      color: 'var(--text-color)',
    },
    '& label': {
      color: 'var(--text-color)',
      fontSize: '0.9em',
    },
    '& input': {
      color: 'var(--text-color)',
    },
    '& textarea': {
      color: 'var(--text-color)',
    },
    '& .MuiSelect-select': {
      color: 'var(--text-color)',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'var(--border-color)',
    },
  },
})(TextField);

export const CssButton = withStyles({
  root: {
    flex: '0 0 auto',
    flexFlow: 'row nowrap',
    '&:disabled': {
      '&.pay_btn': {
        backgroundColor: 'var(--border-dark-color)',
        borderColor: 'var(--border-color)',
        borderRadius: 0,
      },
    },
    '&.brand': {
      backgroundColor: 'var(--brand-color)',
      color: grey[50],
      cursor: 'pointer',
      position: 'relative',
      padding: '0.5em 0.4em',
      minWidth: '110px',
    },
    '&.pay_btn': {
      backgroundColor: grey[900],
      borderRadius: 0,
      color: grey[50],
      cursor: 'pointer',
      position: 'relative',
      padding: '1em',
    },
    '&:hover': {
      '&.brand': {
        backgroundColor: 'var(--brand-color)',
      },
      '&.pay_btn': {
        backgroundColor: grey[800],
      },
    },
    '& .pay_amount': {
      position: 'absolute',
      right: '1em',
    },
  },
  label: {
    lineHeight: 1,
    padding: '0.25em 1em',
  },
})(Button);
